module.exports = __webpack_public_path__ + "img/quote.svg";